import { Dropdown, IconButton, Icons } from '@commenda/kakashi';
import { PaymentMethodIcon } from './PaymentMethodIcon';

interface PaymentCardProps {
  brand: string;
  cardNumber: string;
  expiryDate: string;
  isDefault?: boolean;
  onDelete?: () => void;
}

const PaymentCard = ({
  brand,
  cardNumber,
  expiryDate,
  isDefault,
  onDelete,
}: PaymentCardProps) => {
  const handleDelete = () => {
    if (onDelete) onDelete();
  };

  const formatCardNumber = (number: string) => {
    const lastFour = number.slice(-4);
    return `•••• •••• •••• ${lastFour}`;
  };

  const dropdownMenu = {
    groups: [
      {
        items: [
          {
            label: 'Delete',
            onClick: handleDelete,
            labelClassName: 'text-utility-error-600',
          },
        ],
      },
    ],
  };

  return (
    <div className="w-[351px] h-[84px] p-xl border border-primary-200 rounded-xl bg-primary flex justify-between tertiary-fg-750 text-primary-900 text-info-500">
      <div className="flex items-center gap-4">
        <PaymentMethodIcon brand={brand} />
        <div className="flex flex-col gap-1">
          <span className="text-sm text-primary text-gray-800">
            {formatCardNumber(cardNumber)}
          </span>
          <span className="text-sm text-gray-600">Expires {expiryDate}</span>
        </div>
      </div>
      {isDefault && (
        <span className="px-2 py-1 bg-blue-50 text-white rounded text-xs font-medium h-fit">
          Default
        </span>
      )}

      <Dropdown menu={dropdownMenu} align="end">
        <IconButton
          icon={<Icons.DotsVertical />}
          size="md"
          aria-label="More options"
        />
      </Dropdown>
    </div>
  );
};

export default PaymentCard;
